import React from "react";
import BrandComponents from "./BrandComponents";

function BrandTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Brand Name", field: "brandname" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"BRAND"}
        apiField={"brand"}
        addButton={"Add Brand"}
        createRoute={"/brand/create"}
        updateRoute={"/brand/edit"}
        viewRoute={"/brand/view"}
      />
    </div>
  );
}

export default BrandTable;